import FormValidaciones from "features/Contactos/forms/Validaciones"
import "./styles.scss"

const Validaciones = ({ id }: { id?: string }) => {
  return (
    <div className='tw-px-3'>
      <FormValidaciones contactoId={id} />
    </div>
  )
}

export default Validaciones
